import { useState } from 'react';

import Image from 'next/image';

import Roulette from './Roulette';
import WinLayout from '../../components/Winlayout';
import { core } from '../localizacion/core';

const MainView = ({ setView }: { setView: (view: number) => void }) => {
  const [show, setShow] = useState(false);

  return (
    <div className='min-h-screen bg-[url("/img/v2/register/bgCasino.webp")] bg-cover '>
      <main className="flex flex-col items-center justify-center h-full">
        <Image src="/img/v2/register/casinoName.webp" alt="Nombre Casino" width={300} height={300} className="mt-8" />

        {/* Title */}
        <div className="flex flex-col items-center justify-center gap-1 mt-5">
          <h3 className="text-white text-2xl font-bold">{core.title}</h3>
          <div className="flex gap-2">
            <div className="w-16 h-1 bg-white rounded-full" />
            <h3 className="text-sivarbet-primary text-xl font-medium">{core.subtitle}</h3>
            <div className="w-16 h-1 bg-white rounded-full" />
          </div>
        </div>

        <Roulette setShow={setShow} />
        <div className="flex items-center justify-center gap-3">
          <div className="flex flex-col">
            <Image src="/img/v2/register/games.webp" alt="bgCasino" width={100} height={100} className="mt-8 z-50" />
            <p className="text-sivarbet-primary text-4xl font-bold mt-[-20px] ms-3">{core.play}</p>
            <p className="text-white text-xl ms-6 font-bold mt-[-10px]">{core.more}</p>
          </div>
          <div className="w-px h-[80px] bg-white mt-5" />
          <Image src="/img/v2/register/hondu.webp" alt="Powerbet" width={150} height={150} className="mt-8 z-50" />
        </div>
        <p className="text-sivarbet-third-text text-center text-xs mt-5">{core.footer}</p>
      </main>
      <WinLayout show={show} setView={setView} onClose={() => { return setShow(false); }} view="casino" />
    </div>
  );
};

export default MainView;
